import { render } from "./requestComponent.vue?vue&type=template&id=35861bc8&scoped=true"
import script from "./requestComponent.vue?vue&type=script&lang=js"
export * from "./requestComponent.vue?vue&type=script&lang=js"

import "./requestComponent.vue?vue&type=style&index=0&id=35861bc8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35861bc8"]])

export default __exports__